import React, { useState } from 'react';
import { SmallTitle, palettes } from '@indigo-ag/component-module';
import { ActivityType, Grain } from '@indigo-ag/schema';
import i18next from 'core/i18n';

import { ClientDataModal, ClientDataModalProps } from './components/ClientDataModal/ClientDataModal';
import { SingleRow } from 'features/brazil-grower/components/BrazilGrowerFinance/shared/SingleRow';
import { utils, IClientData, activityTypeTranslations, grainTranslations, createStylesHook } from 'shared';
import {
  PhaseSection,
  PhaseSectionProps
} from 'features/brazil-grower/components/BrazilGrowerFinance/shared/PhaseSection';

const useStyles = createStylesHook({
  activityTypeTitle: {
    color: palettes.neutral[700],
    marginBottom: '24px !important',
    textTransform: 'capitalize'
  }
});

export interface ClientDataSectionProps
  extends Pick<PhaseSectionProps, 'disabled'>,
    Pick<ClientDataModalProps, 'updateCredit'> {
  clientDataInfo?: IClientData;
}

interface ClientDataSectionSummaryProps extends Pick<ClientDataSectionProps, 'clientDataInfo'> {}

export const ClientDataSectionSummary: React.FunctionComponent<ClientDataSectionSummaryProps> = ({
  clientDataInfo
}) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const getGrainsList = (grainProduction: Grain[]): string =>
    grainProduction.map(grain => utils.text.toTitleCase(grainTranslations[grain])).join(', ');

  return clientDataInfo ? (
    <div className="width-100">
      <SmallTitle className={classes.activityTypeTitle}>
        {activityTypeTranslations[clientDataInfo?.customerActivityType!]}
      </SmallTitle>
      {clientDataInfo.customerActivityType === ActivityType.GRAIN_PRODUCTION ? (
        <SingleRow title={i18next.t('types')} content={getGrainsList(clientDataInfo.customerProducts || [])} />
      ) : null}
      <SingleRow title={i18next.t('description')} content={clientDataInfo.customerDescription || '-'} />
    </div>
  ) : null;
};

export const ClientDataSection: React.FunctionComponent<ClientDataSectionProps> = ({
  clientDataInfo,
  updateCredit,
  children,
  ...phaseSectionProps
}) => {
  /**
   * State
   */
  const [modalOpen, setModalOpen] = useState(false);

  const closeClientDataModal = () => setModalOpen(false);

  const openClientDataModal = () => setModalOpen(true);

  return (
    <>
      <PhaseSection
        {...phaseSectionProps}
        open={!!clientDataInfo}
        renderSeparatorBefore
        onClickEdit={openClientDataModal}
        title={i18next.t('clientData')}
      >
        <ClientDataSectionSummary clientDataInfo={clientDataInfo} />
      </PhaseSection>
      <ClientDataModal
        clientDataInfo={clientDataInfo}
        open={modalOpen}
        closeModal={closeClientDataModal}
        updateCredit={updateCredit}
      />
    </>
  );
};
